import { ContentType, ErrorType } from '../../content';
import { NoCard, ModalCard, DefaultCard } from './Cards';

export type CardVariant = 'default' | 'modal' | 'none';

export const Card = ({
  cardVariant,
  error,
  ready,
  jobId,
  contentType,
}: {
  cardVariant?: CardVariant;
  error?: ErrorType;
  ready?: boolean;
  jobId?: string;
  contentType: ContentType;
}) => {
  if (cardVariant === 'none')
    return <NoCard error={error} ready={ready} contentType={contentType} jobId={jobId} />;
  if (cardVariant === 'modal') {
    return <ModalCard error={error} ready={ready} contentType={contentType} jobId={jobId} />;
  }
  return <DefaultCard error={error} ready={ready} contentType={contentType} jobId={jobId} />;
};
